import React from "react";
import { Button } from "@/components/ui/button";
import { authService } from "@/services/authService";
import { FaUserSecret } from "react-icons/fa";

export function ImpersonationBanner() {
  const handleSwitchBack = async () => {
    await authService.endImpersonation();
    window.location.href = "/platform-admin/users";
  };

  if (!authService.isImpersonating()) {
    return null;
  }

  return (
    <div className="flex items-center justify-between gap-2 bg-primary px-4 py-2 text-sm text-primary-foreground">
      <span className="flex items-center gap-2">
        <FaUserSecret className="h-4 w-4" />
        Logged in as {authService.getImpersonatedUserLabel() ?? "another user"}
      </span>
      <Button size="sm" variant="secondary" onClick={handleSwitchBack}>
        Switch back
      </Button>
    </div>
  );
}
